import React from 'react';
import { useIntl } from 'react-intl';

import { TranslationKeys } from 'app/translations';
import { EmploymentEmployeeCategoryEnum } from '../types/employee.types';

export const useEmploymentEmployeeCategorySelectItems = () => {
  const intl = useIntl();

  const employmentEmployeeCategorySelectItems = React.useMemo(() => {
    return [
      {
        value: EmploymentEmployeeCategoryEnum.Dga,
        label: intl.formatMessage({ id: TranslationKeys.global_employeeCategory_dga }),
        element: intl.formatMessage({ id: TranslationKeys.global_employeeCategory_dga }),
      },
      {
        value: EmploymentEmployeeCategoryEnum.OnCallWorker,
        label: intl.formatMessage({ id: TranslationKeys.global_employeeCategory_onCallWorker }),
        element: intl.formatMessage({ id: TranslationKeys.global_employeeCategory_onCallWorker }),
      },
      {
        value: EmploymentEmployeeCategoryEnum.FamilyOfOwner,
        label: intl.formatMessage({ id: TranslationKeys.global_employeeCategory_familyOfOwner }),
        element: intl.formatMessage({ id: TranslationKeys.global_employeeCategory_familyOfOwner }),
      },
      {
        value: EmploymentEmployeeCategoryEnum.PreviousOwner,
        label: intl.formatMessage({ id: TranslationKeys.global_employeeCategory_PreviousOwner }),
        element: intl.formatMessage({ id: TranslationKeys.global_employeeCategory_PreviousOwner }),
      },
    ];
  }, [intl]);

  const getEmploymentEmployeeCategoryDisplayNameByValue = React.useCallback(
    (value: EmploymentEmployeeCategoryEnum) => {
      return employmentEmployeeCategorySelectItems.find(item => item.value === value)?.label ?? '';
    },
    [employmentEmployeeCategorySelectItems],
  );

  return { employmentEmployeeCategorySelectItems, getEmploymentEmployeeCategoryDisplayNameByValue };
};
